import React from 'react';
import { TripRequest } from '@marageti/z4-sdk/lib/travel';
import {
  ContextMenuItemType,
  useApiClient,
  useFetchImmutable,
} from '@marageti/z4-lib';
import { CountryCodeMap } from '@marageti/z4-sdk/lib/standards';
import CardView from './all-card-view';

type AllCardContainerProps = {
  tripRequest: TripRequest;
  contextMenuOptions?: ContextMenuItemType[] | undefined;
};

const AllCardContainer = ({
  tripRequest,
  contextMenuOptions = undefined,
}: AllCardContainerProps) => {
  const apiClient = useApiClient();

  const {
    data: countryCodes,
  } = useFetchImmutable<CountryCodeMap>(apiClient.standardsClient.getCountryCodes, [], true);

  return (
    <CardView
      countryCodes={countryCodes}
      tripRequest={tripRequest}
      contextMenuOptions={contextMenuOptions}
    />
  );
};

export default AllCardContainer;
